<template>
  <require from="controls/bs-form-select"></require>

  <bs-form-select label="Entity Person Responsible for Aviation (EPRA)" placeholder="Please select" value.bind="model.epra & validate:epraPanelRules" options.bind="aviationDeviationTeamUsers" matcher.bind="keywordsItemMatcher" name-path="name" disabled.bind="disabled"></bs-form-select>
  <div class="form-group form-check">
    <input class="form-check-input ${model.isSupportedByEpra ? '' : 'is-invalid'}" type="checkbox" checked.bind="model.isSupportedByEpra & validate" disabled.bind="disabled">
    <label class="form-check-label">I have obtained approval from my EPRA</label>
  </div>
</template>
